module.exports = __webpack_public_path__ + "img/departmentStore.b59b4d03.png";